module.exports = __webpack_public_path__ + "@/assets/img/elo.d01839a7.svg";